import * as React from 'react';
import cx from 'clsx';
import JackpotCountdown from '../JackpotCountdown/JackpotCountdown';
import { JackpotTier, JackpotBoxScale, JackpotStaticTexts } from '../../types';
import styles from './JackpotBox.module.scss';

interface JackpotBoxPropsInterface
  extends Pick<JackpotTier, 'state' | 'releaseTime' | 'releaseMessage'> {
  scale: JackpotBoxScale;
  timeStaticTexts: JackpotStaticTexts['time'];
  children: React.ReactNode | React.ReactNode[];
}

const JackpotBox = ({
  scale,
  state,
  releaseTime,
  releaseMessage,
  timeStaticTexts,
  children,
}: JackpotBoxPropsInterface) => {
  const childrenArray = React.Children.toArray(children);
  return (
    <div
      className={cx(
        styles.container,
        state === 'won' ? styles.won : styles.normal,
        scale === 'tiny' && styles.tiny
      )}
      data-testid="jackpot-box-holder"
    >
      <div>
        {childrenArray[0]}
        {state !== 'won' && scale !== 'medium' && (
          <JackpotCountdown
            jackpotScale={scale}
            jackpotState={state}
            releaseTime={releaseTime}
            releaseMessage={releaseMessage}
            timeStaticTexts={timeStaticTexts}
          />
        )}{' '}
      </div>
      {childrenArray[1] && (
        <div className={styles.nextContainer}>{childrenArray[1]}</div>
      )}
    </div>
  );
};

export default JackpotBox;
